import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {Role} from '../../models/Role.enum';
import {UserHelper} from '../../utils/UserHelper';

@Directive({selector: '[uiRenderIfPermitted]'})
export class UiRenderIfPermittedDirective {
  private currentUserRole: Role;

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private userHelper: UserHelper) {
    this.currentUserRole = this.userHelper.getUser().role;
  }

  @Input() set uiRenderIfPermitted(requiredRole: Role) {
    if (requiredRole <= this.currentUserRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      // Else remove template from DOM
      this.viewContainer.clear();
    }
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/shared/directives/uiRenderIfPermitted.directive.ts